/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateSupplierBody,
  Error,
  GetSuppliers200,
  GetSuppliersParams,
  Supplier,
  UpdateSupplierBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * @summary Create supplier
 */
export type createSupplierResponse201 = {
  data: Supplier
  status: 201
}

export type createSupplierResponse400 = {
  data: Error
  status: 400
}

export type createSupplierResponse401 = {
  data: Error
  status: 401
}

export type createSupplierResponse403 = {
  data: Error
  status: 403
}

export type createSupplierResponse404 = {
  data: Error
  status: 404
}

export type createSupplierResponse422 = {
  data: ValidationError
  status: 422
}

export type createSupplierResponse500 = {
  data: Error
  status: 500
}

export type createSupplierResponseSuccess = (createSupplierResponse201) & {
  headers: Headers;
};
export type createSupplierResponseError = (createSupplierResponse400 | createSupplierResponse401 | createSupplierResponse403 | createSupplierResponse404 | createSupplierResponse422 | createSupplierResponse500) & {
  headers: Headers;
};

export type createSupplierResponse = (createSupplierResponseSuccess | createSupplierResponseError)

export const getCreateSupplierUrl = () => {


  

  return `/suppliers`
}

export const createSupplier = async (createSupplierBody: CreateSupplierBody, options?: RequestInit): Promise<createSupplierResponse> => {
  
  return customFetch<createSupplierResponse>(getCreateSupplierUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSupplierBody,)
  }
);}
  

/**
 * @summary List suppliers
 */
export type getSuppliersResponse200 = {
  data: GetSuppliers200
  status: 200
}

export type getSuppliersResponse400 = {
  data: Error
  status: 400
}

export type getSuppliersResponse401 = {
  data: Error
  status: 401
}

export type getSuppliersResponse403 = {
  data: Error
  status: 403
}

export type getSuppliersResponse404 = {
  data: Error
  status: 404
}

export type getSuppliersResponse500 = {
  data: Error
  status: 500
}

export type getSuppliersResponseSuccess = (getSuppliersResponse200) & {
  headers: Headers;
};
export type getSuppliersResponseError = (getSuppliersResponse400 | getSuppliersResponse401 | getSuppliersResponse403 | getSuppliersResponse404 | getSuppliersResponse500) & {
  headers: Headers;
};

export type getSuppliersResponse = (getSuppliersResponseSuccess | getSuppliersResponseError)

export const getGetSuppliersUrl = (params?: GetSuppliersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/suppliers?${stringifiedParams}` : `/suppliers`
}

export const getSuppliers = async (params?: GetSuppliersParams, options?: RequestInit): Promise<getSuppliersResponse> => {
  
  return customFetch<getSuppliersResponse>(getGetSuppliersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Get supplier by ID
 */
export type getSupplierByIdResponse200 = {
  data: Supplier
  status: 200
}

export type getSupplierByIdResponse401 = {
  data: Error
  status: 401
}

export type getSupplierByIdResponse403 = {
  data: Error
  status: 403
}

export type getSupplierByIdResponse404 = {
  data: Error
  status: 404
}

export type getSupplierByIdResponse500 = {
  data: Error
  status: 500
}

export type getSupplierByIdResponseSuccess = (getSupplierByIdResponse200) & {
  headers: Headers;
};
export type getSupplierByIdResponseError = (getSupplierByIdResponse401 | getSupplierByIdResponse403 | getSupplierByIdResponse404 | getSupplierByIdResponse500) & {
  headers: Headers;
};

export type getSupplierByIdResponse = (getSupplierByIdResponseSuccess | getSupplierByIdResponseError)

export const getGetSupplierByIdUrl = (id: string,) => {


  

  return `/suppliers/${id}`
}

export const getSupplierById = async (id: string, options?: RequestInit): Promise<getSupplierByIdResponse> => {
  
  return customFetch<getSupplierByIdResponse>(getGetSupplierByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Update supplier
 */
export type updateSupplierResponse200 = {
  data: Supplier
  status: 200
}

export type updateSupplierResponse400 = {
  data: Error
  status: 400
}

export type updateSupplierResponse401 = {
  data: Error
  status: 401
}

export type updateSupplierResponse403 = {
  data: Error
  status: 403
}

export type updateSupplierResponse404 = {
  data: Error
  status: 404
}

export type updateSupplierResponse422 = {
  data: ValidationError
  status: 422
}

export type updateSupplierResponse500 = {
  data: Error
  status: 500
}

export type updateSupplierResponseSuccess = (updateSupplierResponse200) & {
  headers: Headers;
};
export type updateSupplierResponseError = (updateSupplierResponse400 | updateSupplierResponse401 | updateSupplierResponse403 | updateSupplierResponse404 | updateSupplierResponse422 | updateSupplierResponse500) & {
  headers: Headers;
};

export type updateSupplierResponse = (updateSupplierResponseSuccess | updateSupplierResponseError)

export const getUpdateSupplierUrl = (id: string,) => {


  

  return `/suppliers/${id}`
}

export const updateSupplier = async (id: string,
    updateSupplierBody: UpdateSupplierBody, options?: RequestInit): Promise<updateSupplierResponse> => {
  
  return customFetch<updateSupplierResponse>(getUpdateSupplierUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSupplierBody,)
  }
);}
  

